import React, {useMemo} from 'react';
import classnames from 'classnames';

import {Spinner} from 'components/controls/index';

import commonStyles from 'styles/common.scss';

const LoadingScreen = () => (
    <div
        className={
            classnames(
                commonStyles.flexCenterContent,
                commonStyles.fullWidthAndHeight,
            )
        }
    >
        <Spinner />
    </div>
);

LoadingScreen.propTypes = {};
LoadingScreen.defaultProps = {};

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/components/controls/LoadingScreen/LoadingScreen.jsx